import React, { Component } from 'react';
import CompanyHealthCheckQuery from 'graphql/queries/company/CompanyHealthCheck.graphql';
import componentQuery from '../../utils/componentQuery';
import theme from '../../styles/themes/default/defaultTheme';
import { getMenuIcon } from '../../components/MenuOptions/MenuOptionIcons';

const fontSize = '20px';

export default class CompanySetupMenu extends Component {
  constructor(props) {
    super(props);
    this.renderTick = this.renderTick.bind(this);
    this.renderCross = this.renderCross.bind(this);
    this.checkHealth = this.checkHealth.bind(this);

    this.state = {
      loaded: false,
    };

    this.checks = [];

    this.checks.push(
      {
        url: '/Company/Country/Workspace',
        section: 'Company',
        title: 'Countries',
        test: () => this.state.countries && this.state.countries.edges.length > 0,
      },
      {
        url: '/Company/Configuration',
        section: 'Company',
        title: 'Company',
        test: () => this.state.company,
      },
      {
        url: '/Company/FinancialCalendar/Workspace',
        section: 'Company',
        title: 'Financial Calendar',
        test: () => this.state.financialCalendars && this.state.financialCalendars.edges.length > 0,
      },
      {
        url: '/Company/Currency/Workspace',
        section: 'Company',
        title: 'Currencies',
        test: () => this.state.currencies && this.state.currencies.edges.length > 0,
      },
      {
        url: '/Nominal/NominalConfig',
        section: 'Nominal',
        title: 'Nominal Config',
        test: () => this.state.nominalConfig,
      },
      {
        url: '/Nominal/Accounts/Workspace',
        section: 'Nominal',
        title: 'Nominal Accounts',
        test: () => this.state.nominals && this.state.nominals.edges.length > 0,
      },
      {
        url: '/Nominal/BusinessCategory/Workspace',
        section: 'Nominal',
        title: 'Nominal Business Categories',
        test: () => this.state.nominalBusinessCategories && this.state.nominalBusinessCategories.edges.length > 0,
      },
      {
        url: '/Nominal/ProductCategory/Workspace',
        section: 'Nominal',
        title: 'Nominal Product Categories',
        test: () => this.state.nominalProductCategories && this.state.nominalProductCategories.edges.length > 0,
      },
      {
        url: '/Nominal/CommonAccountSet/Workspace',
        section: 'Nominal',
        title: 'Nominal Common Account Sets',
        test: () => this.state.nominalCommonAccountSets && this.state.nominalCommonAccountSets.edges.length > 0,
      },
      {
        url: '/Nominal/CustomerAccountSet/Workspace',
        section: 'Nominal',
        title: 'Nominal Customer Account Sets',
        test: () => this.state.nominalCustomerAccountSets && this.state.nominalCustomerAccountSets.edges.length > 0,
      },
      {
        url: '/Nominal/SupplierAccountSet/Workspace',
        section: 'Nominal',
        title: 'Nominal Supplier Account Sets',
        test: () => this.state.nominalSupplierAccountSets && this.state.nominalSupplierAccountSets.edges.length > 0,
      },
      {
        url: '/Nominal/ProductAccountSet/Workspace',
        section: 'Nominal',
        title: 'Nominal Product Account Sets',
        test: () => this.state.nominalProductAccountSets && this.state.nominalProductAccountSets.edges.length > 0,
      },
      {
        url: '/Vat/BusinessStatus/Workspace',
        section: 'Vat',
        title: 'Business VAT Status',
        test: () => this.state.vatBusinessCategories && this.state.vatBusinessCategories.edges.length > 0,
      },
      {
        url: '/Vat/ProductCategory/Workspace',
        section: 'Vat',
        title: 'Product VAT Categories',
        test: () => this.state.vatProductCategories && this.state.vatProductCategories.edges.length > 0,
      },
      {
        url: '/Vat/Authority/Workspace',
        section: 'Vat',
        title: 'VAT Authorities',
        test: () => this.state.vatAuthorities && this.state.vatAuthorities.edges.length > 0,
      },
      {
        url: '/Vat/Rate/Workspace',
        section: 'Vat',
        title: 'VAT Rates',
        test: () => this.state.vatRates && this.state.vatRates.edges.length > 0,
      },
      {
        url: '/Suppliers/SupplierConfig',
        section: 'Suppliers',
        title: 'Supplier Config',
        test: () => this.state.supplierConfig,
      },
      {
        url: '/Customers/PaymentTerm/Workspace',
        section: 'Customers',
        title: 'Customer Payment Terms',
        test: () => this.state.salesPaymentTerms && this.state.salesPaymentTerms.edges.length > 0,
      },
      {
        url: '/Customers/CustomerConfig',
        section: 'Customers',
        title: 'Customer Config',
        test: () => this.state.customerConfig,
      },
      {
        url: '/Products/ProductConfig',
        section: 'Customers',
        title: 'Product Config',
        test: () => this.state.productConfig,
      }
    );
  }

  componentWillMount() {
    this.checkHealth().then(() => {
      let done = true;
      for (let check of this.checks) {
        if (!check.test()) {
          done = false;
          break;
        }
      }

      if (done) {
        this.props.history.push({
          pathname: '/SetupComplete',
          state: {
            previousLocation: this.props.history.location?.pathname || 'back',
          },
        });
      }
    });

    window.setInterval(this.checkHealth, 5000);
  }

  checkHealth() {
    return componentQuery(CompanyHealthCheckQuery, {}, true, 'network-only').then(({ response: data }) => {
      this.setState({
        ...data,
        loaded: true,
      });
    });
  }

  renderTick() {
    if (!this.state.loaded) {
      return (
        <i style={{ fontSize }} className="icon">
          help
        </i>
      );
    }

    return (
      <i style={{ fontSize, color: theme.colors.hintIcon }} className="icon">
        check_circle
      </i>
    );
  }

  renderCross() {
    if (!this.state.loaded) {
      return (
        <i style={{ fontSize }} className="icon">
          help
        </i>
      );
    }

    return (
      <i style={{ fontSize, color: theme.colors.notificationDefault }} className="icon">
        check_circle
      </i>
    );
  }

  renderStatus(test) {
    if (test()) {
      return this.renderTick();
    } else {
      return this.renderCross();
    }
  }

  render() {
    const renderedChecks = [];
    for (let check of this.checks) {
      renderedChecks.push(
        <li
          onClick={() =>
            this.props.history.push({
              pathname: check.url,
              state: { previousLocation: this.props.history.location?.pathname || 'back' },
            })
          }
        >
          <a onClick={(e) => e.preventDefault()}>
            {getMenuIcon(check.section)}
            <div className="navmenu-title">{check.title}</div>
            <div>{this.renderStatus(check.test)}</div>
          </a>
        </li>
      );
    }

    return <React.Fragment>{renderedChecks}</React.Fragment>;
  }
}
